export default "__VITE_ASSET__DKSpFGsH__"